import { call, put } from 'redux-saga/effects';
import ObrasApi from 'Data/Obras.api';
import toastHandler from 'Utils/toastHandler';
import {
  ObraActions,
  GetUsersConstructionSiteAction,
  BindUsersConstructionSiteAction,
} from './Obra.actions';
import {
  loadError,
  updateError,
  listAllTenantOfUserError,
} from 'Utils/Messages';
import { AuthActions } from 'Store/Auth/Auth.actions';
import { IUserLimitsActive } from 'Store/Auth/interfaces/IAuthState';
import { Mixpanel } from 'Utils/MixPanel';
import { queryClient } from 'Context/QueryClientContext';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import { ISharedUser } from 'Data/interfaces/User/ISharedUser';

export function* getDisciplines() {
  try {
    const { data } = yield call(ObrasApi.getDisciplines);
    yield put(ObraActions.getDisciplinesSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('disciplinas');
    toastHandler.showError(error);
    yield put(ObraActions.getDisciplinesFailure(error));
  }
}

export function* getUsersConstructionSite({ payload }: GetUsersConstructionSiteAction) {
  try {
    const { data } = yield call(ObrasApi.getUserByConstructionSite, payload);
    const response = data.data;
    response.ConstructionSiteId = payload;
    yield put(ObraActions.getUsersConstructionSiteSuccess(response));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('usuários da Obra');
    toastHandler.showError(error);
    yield put(ObraActions.getUsersConstructionSiteFailure(error));
  }
}

export function* bindUsersConstructionSite({ payload }: BindUsersConstructionSiteAction) {
  try {
    const {
      firstUserTracking,
      userInfoTracking,
      currentTenantTracking,
      tenantIds,
    } = payload;
    delete payload.firstUserTracking;
    delete payload.userInfoTracking;
    delete payload.currentTenantTracking;
    delete payload.tenantIds;

    yield call(ObrasApi.bindUsersToConstructionSite, payload);
    yield put(ObraActions.bindUsersConstructionSiteSuccess(payload));

    yield Promise.all([
      queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }).then(),
      queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY, Number(payload.ConstructionSiteId)] }).then(),
    ]);

    queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (old) => {
      return old?.map((obra) => {
        if (obra.ConstructionSiteId === payload.ConstructionSiteId) {
          return {
            ...obra,
            SharedUsers: [
              ...obra.SharedUsers.filter((user: ISharedUser) => user.User?.CurrentRoleFk === 1),
              ...payload.SharedUsers,
            ],
          };
        }
        return obra;
      });
    });
    queryClient.setQueryData<IObraResponse>([OBRA_QUERY_KEY, Number(payload.ConstructionSiteId)], (old) => {
      if (old?.ConstructionSiteId === payload.ConstructionSiteId) {
        old.SharedUsers = [
          ...old.SharedUsers.filter((user: ISharedUser) => user.User?.CurrentRoleFk === 1),
          ...payload.SharedUsers,
        ];
      }
      return old;
    });

    const userLimitsActive: IUserLimitsActive = {
      QtyActiveUsers: payload.newInvitedUsers,
    };

    if (firstUserTracking) {
      Mixpanel.track({
        name: 'INVITED_FIRST_USER',
        props: { constructionSiteId: payload.ConstructionSiteId },
        userInfo: userInfoTracking,
        currentListTenant: currentTenantTracking,
        tenantIds,
      });
    }
    yield put(AuthActions.toogleUserLimitsActive(userLimitsActive));

    toastHandler.showSuccess('Usuários atualizados com sucesso.');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : updateError('usuários da Obra');
    toastHandler.showError(error);
    yield put(ObraActions.bindUsersConstructionSiteFailure(error));
  }
}

export function* listConstructionSiteAccounts() {
  try {
    const { data } = yield call(ObrasApi.listConstructionSiteAccountsInfo);
    yield put(ObraActions.listConstructionSiteAccountsSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('contas da construtora');
    toastHandler.showError(error);
    yield put(ObraActions.listConstructionSiteAccountsFailure(error));
  }
}

export function* listConstructionSitesStorage() {
  try {
    const { data } = yield call(ObrasApi.listConstructionSitesStorage);
    yield put(ObraActions.listConstructionSitesStorageSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('contas da construtora');
    toastHandler.showError(error);
    yield put(ObraActions.listConstructionSitesStorageFailure(error));
  }
}

export function* listAllConstructionsSitesOfUser() {
  try {
    const { data } = yield call(ObrasApi.fetchAllConstructionsOfUser);
    yield put(ObraActions.listAllConstructionsSitesOfUserSuccess(data.data));
  } catch (err: any) {
    const error = err.errors ? err.errors[0].Message : listAllTenantOfUserError;
    toastHandler.showError(error);
    yield put(ObraActions.listAllConstructionsSitesOfUserFailure(error));
  }
}
